import React, { useState, useEffect } from "react";
import axios from "axios";
import "./notes.css";
import { IconTimezone } from "@tabler/icons-react";

export default function Notes() {
  const [outing, setOuting] = useState('Loading...');
  const [workHour, setWorkHour] = useState('Loading...');
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchWorkHours = async () => {
      if (!userId || !token) {
        console.error("User ID or Access Token not found!");
        return;
      }

      const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD
      const url = `https://hrmsbackend.prosevo.com/api/attendance/employee-worked-hours/${userId}/?start_date=${today}&end_date=${today}`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data;
        if (data) {
          setOuting(formatTime(data.expected_check_out)); // Convert API time format
          setWorkHour(formatWorkHours(data.worked_hours?.[0]?.worked_hours)); // Convert "H:M:S" to readable format
        }
      } catch (error) {
        console.error("Error fetching work hours:", error);
      }
    };

    fetchWorkHours();
  }, [userId, token]);

  // Function to format API's "HH:MM:SS" to a readable format (AM/PM)
  const formatTime = (time) => {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${period}`;
  };

  // Function to format "H:M:S" to "H Hr M Min"
  const formatWorkHours = (time) => {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(":");
    return `${hours} Hr ${minutes} Min`;
  };

  return (
    <div className="noteParent">
      <div className="noteContainer d-flex flex-column gap-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 style={{ fontWeight: "700", fontSize: "clamp(12px, 1.2vw, 15px)" }} className="mt-1 mb-0 text-black">
            Today's Report
          </h5>
        </div>
        <div className="note d-flex justify-content-between flex-wrap px-3 py-2">
          <div className="d-flex align-items-center justify-content-start gap-3">
            <IconTimezone stroke={2} size={30} />
            <label className="form-check-label text-nowrap fw-medium" style={{ fontSize: "clamp(12px, 1.2vw, 15px)" }}>
              Expected Outing <br />
              <span className="fw-bold">{outing}</span>
            </label>
          </div>
        </div>
        <div className="note d-flex justify-content-between flex-wrap px-3 py-2">
          <div className="d-flex justify-content-center align-items-center gap-3">
            <IconTimezone stroke={2} size={30} />
            <label className="form-check-label text-nowrap fw-medium" style={{ fontSize: "clamp(12px, 1.2vw, 15px)" }}>
              Working Hours <br />
              <span className="fw-bold">{workHour}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
